import { render, staticRenderFns } from "./PolicyViolationProgressBar.vue?vue&type=template&id=77f167a2&"
import script from "./PolicyViolationProgressBar.vue?vue&type=script&lang=js&"
export * from "./PolicyViolationProgressBar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('77f167a2')) {
      api.createRecord('77f167a2', component.options)
    } else {
      api.reload('77f167a2', component.options)
    }
    module.hot.accept("./PolicyViolationProgressBar.vue?vue&type=template&id=77f167a2&", function () {
      api.rerender('77f167a2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/components/PolicyViolationProgressBar.vue"
export default component.exports